import { DefaultActivityFormsDefs } from './ActivityFormContext';

/**
 * Barnvariant av wizardens form-config (NPF-barnvyn).
 *
 * KRITISKT bevarandekrav (brytpunkt 5): denna config får ENDAST ändra
 * presentation — nextFormText och progressValue. Den får ALDRIG
 * ändra formId, nextForm, additionalForm eller nextFormAction. Annars:
 *   - byter formId → AssistantButton försvinner i barnvyn
 *     (CreateActivityHeader renderar via assistantForms=['Title','Date','Duration']).
 *   - tappar additionalForm (MoreOptions) → recurrence/subtask/bild/AI försvinner.
 *
 * Därför härleds barn-configen genom att spreada DefaultActivityFormsDefs och
 * ENBART skriva över de tillåtna presentationsfälten. All struktur
 * (component, formId, nextForm, additionalForm, nextFormAction, m.m.) ärvs
 * oförändrad — strukturell paritet garanteras vid varje ändring i defaults.
 *
 * Texterna är i18n-nycklar (nextFormText löses i NextButton via t(...)) under
 * prefixet 'child.wizard'. Aktiveras enbart när effectiveChildMode är på; annars
 * skickar CreateActivityPage in undefined → DefaultActivityFormsDefs (dagens beteende).
 *
 * OBS: formName överrids INTE för Title/Date/Duration. Dessa steg renderas via
 * CreateActivityHeader, som visar en hårdkodad rubrik ('Create activity') och
 * läser ALDRIG current.formName (bara MoreOptionsHeader gör det, för
 * MoreOptions-stegen). Att sätta formName här hade varit död data.
 */
export const ChildActivityFormsDefs: typeof DefaultActivityFormsDefs = {
  ...DefaultActivityFormsDefs,
  Title: {
    ...DefaultActivityFormsDefs.Title,
    nextFormText: 'child.wizard.nextDate',
    progressValue: 1,
  },
  Date: {
    ...DefaultActivityFormsDefs.Date,
    nextFormText: 'child.wizard.nextDuration',
    progressValue: 2,
  },
  Duration: {
    ...DefaultActivityFormsDefs.Duration,
    nextFormText: 'child.wizard.create',
    progressValue: 3,
  },
};
